import type { Extraction, ExtractionKind } from '@optiro/types';

export const STEPS = ['kind', 'fields', 'review', 'apply'] as const;

/** A lydmemo is written out first, then the flow is the same. */
export const AUDIO_STEPS = ['transcript', ...STEPS] as const;

export type ExtractionStep = (typeof AUDIO_STEPS)[number];

export interface ExtractionFlowState {
  step: ExtractionStep;
  kind: ExtractionKind | null;
  extraction: Extraction | null;
}

export type ExtractionFlowAction =
  | { type: 'transcript_done' }
  | { type: 'transcript_reset' }
  | { type: 'kind_chosen'; kind: ExtractionKind }
  | { type: 'extraction_ready'; extraction: Extraction }
  | { type: 'kind_reset' };

export const initialFlowState: ExtractionFlowState = { step: 'kind', kind: null, extraction: null };

export const audioFlowState: ExtractionFlowState = { ...initialFlowState, step: 'transcript' };

export const flowReducer = (
  state: ExtractionFlowState,
  action: ExtractionFlowAction
): ExtractionFlowState => {
  switch (action.type) {
    case 'transcript_reset':
      return { ...state, step: 'transcript', extraction: null };
    case 'transcript_done':
      return { ...state, step: state.kind ? 'fields' : 'kind' };
    case 'kind_chosen':
      return { ...state, step: 'fields', kind: action.kind };
    case 'extraction_ready':
      return { ...state, step: 'review', extraction: action.extraction };
    case 'kind_reset':
      return { ...state, step: 'kind', kind: null, extraction: null };
  }
};
